<template>
  <div class="app-layout orver-hidden-x" v-loading="loadingDialogData">
    <el-tabs v-model="activeName" type="card" @tab-click="handleTabClick">
      <el-tab-pane label="客户端错误统计 (点击柱状图查看其它日期)" name="first" v-if="!hideClient">
        <div slot="label">
          <i class="el-icon-menu"></i> 客户端错误统计 <small> (点击柱状图查看其它日期)</small>
        </div>
        <div id="barChart" class="chart-box user-chart-box"></div>
        <div class="margin-top-20 table-wrap" v-loading="loadingData">
          <p class="table-wrap-date"><i class="el-icon-time"></i> {{ formQuery.analyzeTime }}</p>
          <el-tabs v-model="activeTabName">
            <el-tab-pane name="first">
              <div slot="label">
                客户端错误统计（{{ tableData.length }}）
                <el-tooltip class="item" effect="dark" placement="right">
                  <div slot="content">
                    柱状图是定时统计的，所以和此处数<br />量不一致，属于正常现象。程序运行时<br />出错，使用window.onerror进行捕<br />获并上报
                  </div>
                  <i class="el-icon-info"></i>
                </el-tooltip>
              </div>
              <el-table :data="tableData" :show-header="false" stripe style="width: 100%">
                <el-table-column>
                  <template #default="{ row }">
                    <div class="table-row" @click="handleEnterDetail(row)">
                      <i class="radius-rad"></i>
                      <i class="txt-bule margin-left-20 margin-right-20">{{ row.errorType }}</i>
                      <small class="txt-gray margin-left-10 margin-right-20">{{
                        row.errorMessage
                      }}</small>
                      <small>
                        <i class="el-icon-s-order marin-right-10 color-red"> </i>（{{
                          row.count
                        }}次）</small
                      >
                      <small>
                        <i class="el-icon-user-solid marin-right-10 color-red"> </i>（{{
                          row.userCount
                        }}人）</small
                      >
                    </div>
                  </template>
                </el-table-column>
                <el-table-column align="center" width="80px">
                  <template #default="{ row }">
                    <el-button
                      size="mini"
                      @click="queryErrorProcessInfo(row)"
                      icon="el-icon-edit"
                    ></el-button>
                  </template>
                </el-table-column>
                <el-table-column align="right" width="220px">
                  <template #default="{ row }">
                    最近：{{ row.latestTime | formatTime }} <i class="el-icon-arrow-right"></i>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
          </el-tabs>
        </div>
      </el-tab-pane>
      <el-tab-pane name="second">
        <div slot="label">
          <i class="el-icon-s-data"></i> 接口错误统计 <small> (点击柱状图查看其它日期)</small>
        </div>
        <div v-loading="loadingData">
          <div id="barChart1" class="chart-box user-chart-box"></div>
          <div class="margin-top-20 table-wrap">
            <p class="table-wrap-date"><i class="el-icon-time"></i> {{ formQuery.analyzeTime }}</p>
            <el-tabs v-model="activeTabName">
              <el-tab-pane name="first">
                <div slot="label">
                  接口错误统计（{{ tableData.length }}）
                  <el-tooltip class="item" effect="dark" placement="right">
                    <div slot="content">
                      柱状图是定时统计的，所以和此处数<br />量不一致，属于正常现象。是通过网关监听<br />接口出错信息并上报
                    </div>
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                </div>
                <el-table :data="tableData" :show-header="false" stripe style="width: 100%">
                  <el-table-column>
                    <template #default="{ row }">
                      <div class="table-row" @click="handleEnterDetail(row)">
                        <i class="radius-rad"></i>
                        <i class="txt-bule margin-left-20 margin-right-20">{{ row.errorType }}</i>

                        <small class="txt-gray margin-left-10 margin-right-20">
                          {{ row.errorMessage }}
                        </small>

                        <small>
                          <i class="el-icon-s-order marin-right-10 color-red"></i>（{{
                            row.count
                          }}次）
                        </small>

                        <small>
                          <i
                            class="el-icon-user-solid
                            marin-right-10 color-red"
                          ></i
                          >（{{ row.userCount }}人）
                        </small>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" width="80px">
                    <template #default="{ row }">
                      <el-button
                        size="mini"
                        @click="queryErrorProcessInfo(row)"
                        icon="el-icon-edit"
                      ></el-button>
                    </template>
                  </el-table-column>
                  <el-table-column align="right" width="220px">
                    <template #default="{ row }">
                      最近：{{ row.latestTime | formatTime }} <i class="el-icon-arrow-right"></i>
                    </template>
                  </el-table-column>
                </el-table>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
    <el-dialog
      :visible.sync="processInfoDialog.visible"
      width="60%"
      @close="processInfoDialog.visible = false"
    >
      <div v-loading="processInfoDialog.loading">
        <el-form align="left" label-width="80px" size="small" ref="form" :model="form">
          <el-form-item label="备注" prop="remark">
            <el-input
              placeholder="请输入备注"
              v-model="form.remark"
              type="textarea"
              resize
            ></el-input>
          </el-form-item>
          <el-form-item label="处理人" prop="remark">
            <div align="left">{{ form.processor }}</div>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="processInfoDialog.visible = false" size="small">取 消</el-button>
          <el-button type="primary" @click="handleSubmit" size="small">确 定</el-button>
        </span>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="dialog.visible" width="90%" @close="handleDialogClose">
      <el-row type="flex">
        <el-col align="left" :span="12" class="font-size-24">
          <p>
            <b> {{ dialog.data.errorType }}: {{ dialog.data.errorMessage }} </b>
          </p>
          <p class="font-size-14 margin-top-10 dialog-info">
            <i class="radius-rad"></i>{{ dialog.data.errorType }}: {{ dialog.data.errorMessage }}
          </p>
          <p class="font-size-14 margin-top-10 dialog-date">
            {{ dialog.data.latestTime | formatTime }}
          </p>
        </el-col>
        <el-col :span="12" align="right" class="font-size-24">
          <div class="dialog-count-group">
            <p class="dialog-count-name">发生次数</p>
            <p class="dialog-count-num">{{ dialog.data.count }}</p>
          </div>
          <div class="dialog-count-group">
            <p class="dialog-count-name">影响用户</p>
            <p class="dialog-count-num">{{ dialog.data.userCount }}</p>
          </div>
        </el-col>
      </el-row>
      <template v-if="dialog.data.errorStack !== 'null'">
        <el-divider></el-divider>
        <el-row>
          <el-col align="left">
            <p class="font-size-18 err-stack-title">
              错误堆栈
              <el-button
                type="text"
                class="source-code-button"
                size="small"
                @click="handleGetSourceCode(dialog.data)"
                :disabled="getSourceCodeDisabled || codeLoading"
                v-if="stack.length === 0"
                >获取错误源码</el-button
              >
            </p>
            <p class="font-size-12 color-gray">
              {{ dialog.data.errorType }}: {{ dialog.data.errorMessage }}
            </p>

            <template v-if="dialog.data.errorStack">
              <template v-if="codeLoading">
                <div class="code-loading">正在获取错误源码</div>
              </template>

              <template v-else>
                <div style="margin-top: 10px">
                  <stack-code :stack="stack" v-if="stack.length" />
                </div>
              </template>

              <el-card
                class="margin-top-10 padding-20"
                shadow="never"
                style="background: #f9fafd"
                v-html="
                  dialog.data.errorStack
                    .replace(/↵/g, '<br />')
                    .replace(/n(\s){1,}at/g, '<br /> at')
                "
              />
            </template>
          </el-col>
        </el-row>
      </template>
      <el-divider></el-divider>
      <el-table border :data="dialog.tableData" v-loading="tableLoading" ref="table">
        <template v-for="(item, index) in columnsList">
          <el-table-column
            v-if="columns[item.label]"
            :width="item.width"
            :min-width="item.minWidth"
            :label="item.label"
            :prop="item.prop"
            :key="index"
            :fixed="item.fixed"
          >
            <template #default="{ row }" v-if="item.tmpl">
              <!-- traceId -->
              <template v-if="item.label === '链路id'">
                <el-link type="primary" @click="handleRedirectTrack(row)">{{
                  row.traceId
                }}</el-link>
              </template>
              <template v-if="item.label === '接口地址'">
                <el-link type="primary" @click="handleRedirectUri(row)">{{ row.uri }}</el-link>
              </template>
              <template v-if="item.label === '错误信息'">
                {{ row.errorType }}: {{ row.errorMessage }}
              </template>
              <template v-if="item.label === '事件时间'">
                {{ row.eventTime | formatTime }}
              </template>
              <template v-else-if="item.label === '操作'">
                <el-button
                  :disabled="!row.sessionId"
                  type="primary"
                  size="mini"
                  @click="handleSearchBehavior(row)"
                  >查看</el-button
                >
              </template>
            </template>
          </el-table-column>
          <template v-else></template>
        </template>
      </el-table>
      <el-row type="flex" justify="end" class="margin-top-10">
        <el-pagination
          background
          @size-change="searchDialog()"
          @current-change="searchDialog()"
          :current-page.sync="formQuery.pageNum"
          :page-size.sync="formQuery.pageSize"
          :page-sizes="[10, 20, 50, 100]"
          layout="total, sizes, prev, pager, next"
          :total="dialog.tableTotal"
        />
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialog.visible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import {
  queryClientErrorStat,
  queryApiErrorStat,
  queryClientErrorSummary,
  queryApiErrorSummary,
  queryClientErrorBehavior,
  queryApiErrorBehavior,
  queryErrorProcessInfo,
  addErrorProcessInfo,
} from '@/api/log/index';
import { getStackParseCode } from '@/api/report/index';
import { parseTime } from '@/utils';
import { stackParse } from '@/utils/source-code';
import StackCode from '@/components/source-code/code.vue';
import moment from 'moment';

export default {
  name: 'ApplicationAnalysisErrorReportComs',
  components: {
    StackCode,
  },
  props: {
    isAlonePage: {
      type: Boolean,
      default: false,
    },
    defaultTab: {
      type: String,
    },
  },
  data() {
    return {
      stack: [],
      form: {
        remark: '',
        processor: '',
      },
      processInfoDialog: {
        loading: false,
        visible: false,
        data: {},
      },
      dialog: {
        visible: false,
        data: {},
        tableData: [],
        tableTotal: 0,
      },
      hideClient: false,
      formQuery: {
        pageNum: 1,
        pageSize: 20,
        analyzeTime: '',
      },
      tableLoading: false,
      codeLoading: false,
      loadingDialogData: false,
      loadingData: false,
      tableData: [],
      activeTabName: 'first',
      activeName: '',
      columnsList: [
        {
          label: '错误信息',
          minWidth: 120,
          tmpl: true,
        },
        {
          label: '链路id',
          prop: 'traceId',
          tmpl: true,
        },
        {
          label: '页面',
          prop: 'pagePath',
        },
        {
          label: '浏览器名称',
          prop: 'browserName',
        },
        {
          label: 'UA',
          prop: 'browserUserAgent',
        },
        {
          label: '设备',
          prop: 'deviceModel',
        },
        {
          label: '客户IP地址',
          prop: 'ip',
        },
        {
          label: '会话id',
          prop: 'sessionId',
        },
        {
          label: '接口地址',
          prop: 'uri',
          tmpl: true,
        },
        {
          label: '事件时间',
          tmpl: true,
          minWidth: 120,
        },
        {
          label: '操作',
          tmpl: true,
          fixed: 'right',
        },
      ],
      columns: {
        错误信息: true,
        链路id: true,
        浏览器名称: true,
        UA: true,
        设备: true,
        客户IP地址: true,
        会话id: true,
        接口地址: true,
        事件时间: true,
        操作: true,
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [
          {
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date());
            },
          },
        ],
      },
      barChart: null,
      barChart1: null,
    };
  },
  created() {
    if (this.isAlonePage) {
      const { name, query } = this.$route;
      this.$router.replace({
        name,
        query: {
          ...query,
          to: moment().format('YYYY-MM-DD'),
        },
      });
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  mounted() {
    const { pageSource } = this.$route.query;
    if (pageSource === 'server' || this.isAlonePage) {
      this.hideClient = true;
    }

    // 当窗口发生变化时
    window.addEventListener('resize', this.handleResize);

    this.activeName = !this.isAlonePage ? this.$route.query.name : this.defaultTab;
    this.handleTabClick();
  },
  computed: {
    ...mapGetters('app', ['source', 'env', 'serverName', 'bizChannel']),
    getSourceCodeDisabled() {
      return this.dialog?.tableData?.length === 0;
    },
  },
  watch: {
    source: {
      handler() {
        this.search();
      },
    },
    serverName: {
      handler() {
        this.search();
      },
    },
    env: {
      handler() {
        this.search();
      },
    },
    bizChannel: {
      handler() {
        this.search();
      },
    },
  },
  methods: {
    handleRedirectTrack(row) {
      const link = this.$router.resolve({
        name: 'LogAnalysisTrackingLink',
        query: {
          traceId: row.traceId,
        },
      });
      window.open(link.href, '_blank');
    },
    handleRedirectUri(row) {
      const link = this.$router.resolve({
        name: 'AnalyzeInterfaceList',
        query: {
          uri: row.uri,
          time: moment(row.eventTime).format('YYYY-MM-DD'),
        },
      });
      window.open(link.href, '_blank');
    },
    handleDialogClose() {
      this.stack = [];
      this.formQuery.pageNum = 1;
      this.formQuery.pageSize = 20;
      this.dialog.visible = false;
    },
    handleSearchBehavior({ sessionId }) {
      const {
        formQuery: { analyzeTime: to },
      } = this;

      const query = { to, sessionId };
      if (this.hideClient) query.pageSource = 'server';

      const link = this.$router.resolve({
        name: this.hideClient ? 'AnalyzeErrorReportDetail' : 'ApplicationAnalysisErrorReportDetail',
        query,
      });

      window.open(link.href, '_blank');
    },
    async searchDialog(page) {
      try {
        this.tableLoading = true;
        if (page) this.formQuery.pageNum = page;
        const {
          formQuery: { pageNum, pageSize, analyzeTime },
          dialog: {
            data: { errorMessage, errorType },
          },
        } = this;

        const params = {
          errorType,
          errorMessage,
          analyzeTimeFrom: `${analyzeTime} 00:00:00`,
          analyzeTimeTo: `${analyzeTime} 23:59:59`,
        };

        const isFirstTab = this.activeName === 'first';
        const method = isFirstTab ? queryClientErrorBehavior : queryApiErrorBehavior;
        const { data } = await method({
          ...params,
          pageNum,
          pageSize,
        });

        this.dialog.tableData = data?.list || [];
        this.dialog.tableTotal = data?.total || 0;
      } finally {
        this.tableLoading = false;
      }
    },
    async handleGetSourceCode() {
      if (this.dialog.tableData?.length <= 0) {
        this.$message.error('无可获取的错误');
        return;
      }

      const [firstItem] = this.dialog.tableData;
      const { eventAttr } = firstItem;
      try {
        const { errorStack, app, appVersion } = eventAttr;
        if (!errorStack || !app || !appVersion) {
          this.$message.error('无查找到指定版本的源码');
          return;
        }
        this.codeLoading = true;

        const { data } = await getStackParseCode({
          stack: errorStack,
          app,
          appVersion,
        });

        this.stack = stackParse(data);
        console.log(this.stack);
      } catch (e) {
        this.stack = [];
        // this.$message.error('获取错误源码失败');
      } finally {
        this.codeLoading = false;
      }
    },
    async handleEnterDetail(row) {
      try {
        this.loadingDialogData = true;
        Object.assign(this.dialog, {
          visible: true,
          data: row,
          tableData: [],
        });
        await this.searchDialog();
      } catch (e) {
        console.log(e);
      } finally {
        this.loadingDialogData = false;
      }
    },
    handleTabClick() {
      this.$nextTick(() => {
        if (this.activeName === 'first') {
          // eslint-disable-next-line no-unused-expressions
          this.barChart1 && this.barChart1.dispose();
        } else {
          // eslint-disable-next-line no-unused-expressions
          this.barChart && this.barChart.dispose();
        }
        this.search();
      });
    },
    async queryErrorProcessInfo(row) {
      try {
        const {
          $route: {
            query: { to: errorDate },
          },
        } = this;
        const { errorMessage, errorType } = row;
        const { data } = await queryErrorProcessInfo({
          errorMessage,
          errorType,
          errorDate,
        });

        this.form.remark = data?.remark || '';
        this.form.processor = data?.processor || '';
        this.processInfoDialog.visible = true;
        this.processInfoDialog.data = row;
      } catch (e) {
        console.log(e);
      }
    },
    async handleSubmit() {
      try {
        this.processInfoDialog.loading = true;
        const {
          $route: {
            query: { to: errorDate },
          },
          form: { remark },
          processInfoDialog: { data: row },
        } = this;
        const { errorMessage, errorType } = row;
        await addErrorProcessInfo({
          errorMessage,
          errorType,
          errorDate,
          remark,
        });

        this.form.remark = '';
        this.processInfoDialog.visible = false;
        this.processInfoDialog.loading = false;
        this.$Message.success('备注成功');
      } catch (e) {
        this.processInfoDialog.loading = false;
        console.log(e);
      }
    },
    async search() {
      try {
        this.loadingDialogData = true;
        const {
          $route: {
            query: { to: analyzeTimeTo },
          },
        } = this;

        const analyzeTimeFrom = parseTime(
          new Date(new Date(analyzeTimeTo || moment().format('YYYY/MM/DD')).getTime() - 2592000000),
          'yyyy-MM-dd',
        );

        const params = {
          analyzeTimeFrom,
          analyzeTimeTo: analyzeTimeTo || moment().format('YYYY-MM-DD'),
        };

        const isFirstTab = this.activeName === 'first';
        const method = isFirstTab ? queryClientErrorStat : queryApiErrorStat;
        const chartType = isFirstTab ? 'barChart' : 'barChart1';
        const yArray = [];
        const xArray = [];
        const {
          data: { clientErrors, apiErrors },
        } = await method(params);
        const array = isFirstTab ? clientErrors : apiErrors;
        array.forEach(({ currentAnalyzeTime, current }) => {
          yArray.push(current);
          xArray.push(currentAnalyzeTime);
        });

        this[chartType] = this.$echarts.init(document.getElementById(chartType));
        const option = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              // 坐标轴指示器，坐标轴触发有效
              type: 'line', // 默认为直线，可选为：'line' | 'shadow'
            },
          },
          grid: {
            height: '160',
            left: '2%',
            right: '2%',
            bottom: '0%',
            containLabel: true,
          },
          color: ['#5d5cb6'],
          xAxis: [
            {
              type: 'category',
              data: xArray,
              // 设置轴线的属性
              axisLine: {
                lineStyle: {
                  type: 'dashed',
                  color: '#838383',
                  // width: 8
                },
              },
              axisLabel: {
                interval: 0,
                rotate: 30,
                // textStyle: {
                color: '#838383', // 坐标值得具体的颜色
                // },
              },
            },
          ],
          yAxis: [
            {
              name: '次数',
              type: 'value',
              // 网格
              splitLine: {
                show: false,
              },
              // 设置轴线的属性
              axisLine: {
                show: true,
                lineStyle: {
                  type: 'dashed',
                  color: '#838383',
                  // width: 8
                },
              },
              // 数值
              axisLabel: {
                // textStyle: {
                color: '#838383', // 坐标值得具体的颜色
                // },
              },
            },
          ],
          series: [
            {
              name: '发生次数',
              barWidth: 25, // 柱图宽度
              type: 'bar',
              emphasis: {
                focus: 'series',
              },
              data: yArray,
            },
          ],
        };
        this[chartType].setOption(option);
        this[chartType].on('click', ({ name }) => {
          this.searchTableData(name);
        });

        this.searchTableData(array[array.length - 1].currentAnalyzeTime);
      } catch (e) {
        console.log(e);
      } finally {
        this.loadingDialogData = false;
      }
    },
    async searchTableData(currentAnalyzeTime) {
      this.formQuery.analyzeTime = currentAnalyzeTime;

      const params = {
        analyzeTimeFrom: `${currentAnalyzeTime} 00:00:00`,
        analyzeTimeTo: `${currentAnalyzeTime} 23:59:59`,
      };

      const isFirstTab = this.activeName === 'first';
      const method = isFirstTab ? queryClientErrorSummary : queryApiErrorSummary;
      const {
        data: { clientErrorSummarys, apiErrorSummarys },
      } = await method(params);
      // eslint-disable-next-line max-len
      this.tableData.splice(
        0,
        this.tableData.length,
        ...(isFirstTab ? clientErrorSummarys : apiErrorSummarys),
      );
    },
    handleResize() {
      if (this.activeName === 'first') {
        // eslint-disable-next-line no-unused-expressions
        this.barChart && this.barChart.resize(); // 重绘echart图表
      } else {
        // eslint-disable-next-line no-unused-expressions
        this.barChart1 && this.barChart1.resize(); // 重绘echart图表
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.code-loading {
  text-align: center;
  padding: 5px;
  color: #bfbfbf;
  font-size: 13px;
}
.color-green {
  color: #00af56;
}
.color-red {
  color: #f85149;
}
.color-gray {
  color: #a3a5b0;
}
.user-chart-box {
  height: 200px;
}
.small-chart-box {
  height: 220px;
}
.radius-rad {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #e67482;
}
.txt-bule {
  color: #1890ff;
}
.txt-gray {
  color: #666;
}
.app-layout {
  min-width: 928px;
  padding: 20px;
  background: #fff;
  min-height: calc(100vh - 0);
}
.table-wrap {
  position: relative;
}
.table-wrap-date {
  position: absolute;
  right: 0;
  top: 10px;
  color: #5d5cb6;
  font-weight: bold;
}
.table-row {
  color: #303133;
  cursor: pointer;
}

.dialog-info {
  color: #a6a6a6;
  .radius-rad {
    width: 20px;
    height: 20px;
    margin-right: 8px;
    vertical-align: text-bottom;
  }
}
.dialog-date {
  color: #a6a6a6;
  margin-left: 30px;
}

.dialog-count-group {
  display: inline-block;
  text-align: center;
  &:last-child {
    margin: 0 40px;
  }
}
.dialog-count-name {
  font-size: 16px;
  font-weight: 700;
  color: #c1bdbd;
}
.dialog-count-num {
  color: #556eba;
  font-size: 26px;
}

.err-stack-title {
  position: relative;
}

.source-code-button {
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
}
</style>
